module.exports = __webpack_public_path__ + "assets/img/notification-bell.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/notification-bell.png
// module id = 451
// module chunks = 0